import { render, staticRenderFns } from "./form-v1.vue?vue&type=template&id=7f3feab9"
import script from "./form-v1.vue?vue&type=script&lang=js"
export * from "./form-v1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports